import { AllCommunityModule, ModuleRegistry } from "ag-grid-community";
import { AgGridReact } from "ag-grid-react";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

ModuleRegistry.registerModules([AllCommunityModule]);

const Table = ({
  rowData,
  columnDefs,
  onRowClick,
  gridOptions = {},
  gridRef,
  height = "calc(100% - 40px)",
  wrapClassName = "",
}) => {
  const defaultColDef = {
    flex: 1,
    wrapText: true,
    autoHeight: true,
    cellStyle: { whiteSpace: "normal" },
  };

  const wrapperClass = ["ag-theme-quartz", wrapClassName].filter(Boolean).join(" ");

  return (
    <div className={wrapperClass} style={{ width: "100%", height }}>
      {rowData && rowData.length > 0 ? (
        <AgGridReact
          ref={gridRef}
          rowData={rowData}
          columnDefs={columnDefs}
          defaultColDef={defaultColDef}
          onRowClicked={onRowClick}
          domLayout="autoHeight"
          {...gridOptions}
        />
      ) : (
        <div className="admin-tenant-grid-empty text-center py-5 px-3">
          <p className="mb-1 fw-semibold text-secondary">No data available</p>
          <p className="mb-0 small text-muted">Try adjusting filters or refresh the list.</p>
        </div>
      )}
    </div>
  );
};

export default Table;